import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { SearchToneAPI } from '../api/search/searchtone/searchtoneapi';
import { SearchToneRequest } from '../api/search/searchtone/searchtonerequest';
import { SearchToneResponse } from '../api/search/searchtone/searchtoneresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { SearchToneAPIProcessorImpl } from '../processor/searchtoneapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { SearchToneBasedOnCodeAPIProcessorImpl } from '../processor/searchtonebasedoncodeapiprocessor';
import { SearchBasedOnCodeToneAPI } from '../api/search/searchtonebasedoncode/searchtonebasedoncodeapi';
import { SearchToneBasedOnCodeRequest } from '../api/search/searchtonebasedoncode/searchtonebasedoncoderequest';
import { SearchToneBasedOnCodeResponse } from '../api/search/searchtonebasedoncode/searchtonebasedoncoderesponse';

export class SearchToneProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(SearchToneProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getSearchTone():APIProcessor<SearchToneRequest, SearchToneResponse>
    {
        this.logger.log("getSearchTone() invoked");
        return new SearchToneAPIProcessorImpl(this.getContext(), new SearchToneAPI(this.getHttpClient(), this.getContext()));
    }

    getToneBasedOnCode():APIProcessor<SearchToneBasedOnCodeRequest, SearchToneBasedOnCodeResponse>
    {
        this.logger.log("getSearchTone() invoked");
        return new SearchToneBasedOnCodeAPIProcessorImpl(this.getContext(), new SearchBasedOnCodeToneAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/searchtoneprocessorfactory.tsx